export default __webpack_public_path__ + "development-1.png";